import jwtDecode from 'jwt-decode';
import store from './reduxStore';  
import eventManager from './eventManager';   
import requestManager from './requestManager';  
import {log} from './utils';
import uuid from 'uuid/v4';

export default class ShapesClient {
	constructor(url, token, logging = false, isPrivate = false) {
		this.client_id = uuid();
		
		const _log = (type, ...args) => {
			if(!logging){return}
			try{
				return log[type](...args);
			}catch(e){
				console.error(e);
			}
		}

		try{
			if(typeof window !== 'undefined' && !isPrivate && window.ShapesSDKClient){
				throw("Found existing instance of shapes on page. Will not override. Consider using client exposed from shapes.ready event or using the shared client at window.ShapesSDKClient");
			}

			const {pid, exp} = jwtDecode(token)
			const now = Math.round(Date.now() / 1000);
			if(!pid){throw({
				type: "invalid_token",
				message: "This token is invalid"
			})}
			if(exp < now){throw({
				type: "invalid_token",
				message: "This token has expired"
			})}

			const _profile_id = pid;
			const _store = new store(this.client_id, _profile_id);
			const _eventManager = new eventManager(_store, _log, isPrivate);
			const _requestManager = new requestManager(
				this.client_id, 
				url, 
				token, 
				_store, 
				_log,
				_eventManager
			);

			this.clear = () => {
				_store.dispatch({type: "shapes.reset"});
			};

			/// need to scope inside function
			this.on = (...args) => _eventManager.subscribe(...args)
			this.off = (...args) => _eventManager.unsubscribe(...args)
			this.find = (path) => _store.get(path);
			this.hydrate = (path) => _requestManager.hydrate(path);
			this.get = (...args) => _requestManager.get(...args);
			this.put = (...args) => _requestManager.put(...args);
			this.post = (...args) => _requestManager.post(...args);
			this.delete = (...args) => _requestManager.delete(...args);
			this.dispatch = (...args) => _store.dispatch(...args);

			this.ready = true;

			_eventManager.handler("shapes.ready", {
				client_id: this.client_id,
				client: this
			})

			if(!isPrivate && typeof window !== 'undefined'){
				window.ShapesSDKClient = this
			}
		}catch(e){
			_log('error', e)
          
			this.error = true;
			return;
		}
	}
}